module.exports = __webpack_public_path__ + "img/white-valid.6453ecba.svg";